<template>
  <div>
    <v-card class="mx-auto" width="95%">
      <v-card-title>
        <v-toolbar-title>Editorial Publicado</v-toolbar-title>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="editorialPublicado"
        :items-per-page="5"
        class="elevation-0"
      >
        <template v-slot:item="row">
          <tr>
            <td>
              <v-row style="align-items: center;">
                <v-col cols="2">
                  <v-avatar size="32px">
                    <v-img
                      :src="row.item.autor.foto"
                      v-if="!!row.item.autor.foto && row.item.autor.foto !== 'null'"
                    ></v-img>
                    <v-icon large v-else>mdi-account-circle</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="10" style="text-align: left;">{{ row.item.autor.nome }}</v-col>
              </v-row>
            </td>
            <td>{{ row.item.titulo }}</td>
            <td>{{ row.item.descricao }}</td>
            <td>{{ dateFormatted(row.item.data) }}</td>
            <td>
              <v-btn
                x-small
                class="mb-2"
                text
                @click="despublicEditorial(row.item.id)"
                title="Despublicar"
              >
                <v-icon dark>cloud_download</v-icon>
              </v-btn>
              <v-btn
                x-small
                class="mb-2"
                text
                @click="mostrarDialogSomarIteracao(row.item)"
                title="Interações"
                v-if="userAdmin"
              >
                <v-icon dark>trending_up</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-divider class="mx-4" vertical></v-divider>

    <v-card class="mx-auto" width="95%">
      <v-card-title>
        <v-toolbar-title>Lista de Editorial</v-toolbar-title>
      </v-card-title>
      <v-toolbar color="darken-1" class="mb-1" elevation="0">
        <v-row>
          <v-col cols="12" sm="12" md="5">
            <mb-text-field
              label="Buscar por titulo"
              prependInnerIcon="search"
              @click:clear="limparTexto()"
              v-model="buscar.titulo"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <mb-data
              label="Buscar por data"
              prependInnerIcon="event"
              :data="buscar.data"
              @dataSelecionada="buscar.data = $event"
            />
          </v-col>
        </v-row>
      </v-toolbar>
      <v-data-table
        :headers="columns"
        :items="editorialNaoPublicadoFiltrados"
        :items-per-page="5"
        class="elevation-0"
      >
        <template v-slot:item="row">
          <tr>
            <td>
              <v-row style="align-items: center;">
                <v-col cols="2">
                  <v-avatar size="32px">
                    <v-img
                      :src="row.item.autor.foto"
                      v-if="!!row.item.autor.foto && row.item.autor.foto !== 'null'"
                    ></v-img>
                    <v-icon large v-else>mdi-account-circle</v-icon>
                  </v-avatar>
                </v-col>
                <v-col cols="10" style="text-align: left;">{{ row.item.autor.nome }}</v-col>
              </v-row>
            </td>
            <td>{{ row.item.titulo }}</td>
            <td>{{ row.item.descricao }}</td>
            <td>{{ dateFormatted(row.item.data) }}</td>
            <td>
              <v-btn
                x-small
                class="mb-2"
                text
                @click="abrirPublicacoes(row.item.id)"
                title="Publicações"
              >
                <v-icon dark>all_inbox</v-icon>
              </v-btn>
              <v-btn
                x-small
                class="mb-2"
                text
                @click="publicEditorial(row.item.id)"
                title="Publicar"
              >
                <v-icon dark>cloud_upload</v-icon>
              </v-btn>
              <v-btn x-small class="mb-2" text @click="mostrarDialogEditar(row.item)">
                <v-icon dark>edit</v-icon>
              </v-btn>
              <v-btn
                x-small
                class="mb-2"
                text
                @click="deletarEditorial(row.item.id)"
                title="Remover"
              >
                <v-icon dark>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-toolbar color="darken-1" class="mb-1" elevation="0">
        <v-btn
          dark
          rounded
          color="darken-2"
          class="text-transform-none"
          @click="mostrarDialogCadastro()"
        >
          <v-icon>add</v-icon>Novo Editorial
        </v-btn>
      </v-toolbar>
    </v-card>

    <v-dialog v-model="dlgForm" transition="dialog-bottom-transition">
      <formEditorial
        v-if="dlgForm"
        @salvar="salvarEditorial"
        @fechar="fecharDlg"
        :viewEditorial="isNew"
        :setEditorial="editorial"
      />
    </v-dialog>

    <v-dialog v-model="dlgIteracao" transition="dialog-bottom-transition" width="500">
      <FormIteracao
        v-if="dlgIteracao"
        @salvar="salvarIteracao"
        @fechar="fecharDialogSomarIteracao"
        :editorial="editorialId"
      />
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import EditorialInput from "../../classes/editorialInput";
import FormEditorial from "./FormEditorial.vue";
import EditorialService from "../../services/editorialServices";
import FormIteracao from "@/views/editorial/FormIteracao.vue";
export default {
  data() {
    return {
      userAdmin: false,
      data: new Date().toISOString().substr(0, 10),
      isNew: true,
      dlgForm: false,
      dlgIteracao: false,
      editorialId: null,
      editorial: new EditorialInput(),
      columns: [
        { text: "Autor", align: "left" },
        { text: "Titulo", align: "center" },
        { text: "Descricao", align: "center", width: "40%" },
        { text: "Data", align: "center" },
        { text: "" },
      ],
      buscar: {
        titulo: "",
        data: "",
      },
      editorialPublicado: [],
      editorialNaoPublicado: [],
    };
  },
  beforeCreate() {},
  methods: {
    carregarLista() {
      this.carregarListaPublicado();
      this.carregarListaNaoPublicado();
    },
    async carregarListaPublicado() {
      var resultPub = await EditorialService.listarEditorialPublicado();
      this.editorialPublicado = resultPub.data.data.listarEditorial;
    },
    async carregarListaNaoPublicado() {
      var resultNaoPub = await EditorialService.listarEditorialNaoPublicado();
      this.editorialNaoPublicado = resultNaoPub.data.data.listarEditorial;
    },
    mostrarDialogCadastro() {
      this.isNew = true;
      this.editorial = new EditorialInput();
      this.dlgForm = true;
    },
    mostrarDialogEditar(editorial) {
      this.isNew = false;
      this.editorial = editorial;
      this.editorial.autor_id = editorial.autor.id;
      this.editorial.data = moment(editorial.data).format("YYYY-MM-DD");
      this.dlgForm = true;
    },
    salvarEditorial(value) {
      this.editorial = value;
      if (this.isNew) {
        EditorialService.criarEditorial(this.editorial).then((result) => {
          if (result.data.errors) {
            this.$toast.error(result.data.errors);
          } else {
            this.editorialNaoPublicado.push(result.data.data.criarEditorial);
            this.$toast.info("Editorial salvo com sucesso.");
            this.dlgForm = false;
          }
        });
      } else {
        EditorialService.atualizarEditorial(this.editorial).then((result) => {
          if (result.data.errors) {
            this.$toast.error(result.data.errors);
          } else {
            this.carregarListaNaoPublicado();
            this.$toast.info("Editorial editado com sucesso.");
            this.dlgForm = false;
          }
        });
      }
    },
    async publicEditorial(editorialId) {
      await EditorialService.publicarEditorial(
        editorialId,
        new Date().toISOString().substr(0, 10)
      );
      this.carregarLista();
    },
    async despublicEditorial(editorialId) {
      await EditorialService.despublicarEditorial(editorialId);
      this.carregarLista();
    },
    async deletarEditorial(editorialId) {
      var result = await EditorialService.deletarEditorial(editorialId);
      if (result.data.errors) {
        this.$toast.error("Não é possivel remover o editorial.");
      } else {
        this.$toast.info("Editorial removido com sucesso.");
        await this.carregarListaNaoPublicado();
      }
    },
    fecharDlg() {
      this.dlgForm = false;
    },
    dataSelecionadaFn(dt) {
      console.log(dt);
    },
    dateFormatted(date) {
      moment.locale("pt-BR");
      return date ? moment(date).format("dddd, DD/MM/YYYY") : "";
    },
    nomeTitulo(items, filters, filter) {
      return filter.titulo.toLowerCase().includes(filters.toLowerCase());
    },
    columnValueList(val) {
      return this.editorialNaoPublicado.map((d) => d[val]);
    },
    limparTexto() {
      this.buscar.titulo = "";
    },
    abrirPublicacoes(editorialId) {
      this.$router.push({ path: `/editorial/${editorialId}/publicacao` });
    },
    salvarIteracao() {
      //this.dlgIteracao = false;
    },
    mostrarDialogSomarIteracao(item) {
      this.editorialId = item.id;
      this.dlgIteracao = true;
    },
    fecharDialogSomarIteracao() {
      this.dlgIteracao = false;
    },
  },
  watch: {
    // searchTitulo: (val) => {
    //     alert(val)
    // }
    buscar: {
      handler() {},
      deep: true,
    },
  },
  created() {
    this.userAdmin = this.$store.getters["usuario/isAdminUser"];
    this.carregarLista();
  },
  computed: {
    editorialNaoPublicadoFiltrados() {
      return this.editorialNaoPublicado.filter((d) => {
        return (
          (this.buscar.titulo === null ||
            d.titulo
              .toLowerCase()
              .includes(this.buscar.titulo.toLowerCase())) &&
          (this.buscar.data === null || d.data.includes(this.buscar.data))
        );
      });
    },
  },
  components: {
    FormEditorial,
    FormIteracao,
  },
};
</script>

<style>
</style>
